import { createFileRoute } from "@tanstack/react-router";
import { SpacePage } from "@/features/space/SpacePage";

export const Route = createFileRoute("/_app/spaces/$space")({ component: Page });

function Page() {
  const { space } = Route.useParams();
  return <SpacePage slug={space} />;
}
